import React, { Fragment, useEffect, useState } from 'react';
import './AdminSchoolDetailPageBody.scss';
import PageBodyWrapper from "root/PageBodyWrapper";
import { getProviderDetails } from "root/DataFunctions/ProviderFns";
import { getDataFromResponse } from "root/DataFunctions/BaseDataFns";
import { useParams } from "react-router-dom";
import { Tab, Tabs } from "react-bootstrap";
import TeacherDashboardContainer from "root/Dashboard/TeacherDashboardContainer";
import DocumentsContainer from "root/DocumentsContainer";
import TeachersContainer from "root/TeachersContainer";
import FormSchoolDetails from "root/Forms/FormSchoolDetails";
import ContainerButton from "root/ContainerButton";
import HistoryContainer from "root/HistoryContainer";
import useModalAddSchool, { AddSchoolModalMode } from "root/Modals/useModalAddSchool";
import { isGovernorRole } from "root/DataFunctions/GovernorFunctions";
import { useGlobalContext } from "root/Contexts/GlobalContext";

const AdminSchoolDetailPageBody = ( props ) =>
{

    const {user_type} = useGlobalContext();

    const [renderModal, activateModal ] = useModalAddSchool() ;
    const { provider_id } = useParams ();
    const [ data, setData ] = useState ( { loading: true, data: [] } );

    useEffect ( () =>
    {
        getData ();
    }, [] );

    const getData = () =>
    {
        getProviderDetails ( 'current', encodeURIComponent ( provider_id ), ( response ) =>
        {
            setData ( { loading: true, data: data } )

            const returnData = getDataFromResponse ( response );

            setData ( { loading: false, data: returnData } )
        } )
    }

    const onDialogClosed = (operation) =>
    {
        getData() ;
    }

    const onClickAddSchool = () =>
    {
        activateModal ( encodeURIComponent ( provider_id ), onDialogClosed, AddSchoolModalMode.EDIT ) ;
    }

    return (
        <Fragment>
            <PageBodyWrapper title='School Details'>
                {!isGovernorRole(user_type) && <ContainerButton title='Edit School Details' onClick={onClickAddSchool}/>}
                <div className='sections-grid-rows'>
                    <div className='table-section-rows'>
                        { data.loading === false && <h5 style={{ color: 'var(--s360-safe-font-dark-blue' }}><div>{ data.data[ 0 ].provider_name }</div></h5> }
                        { data.loading === false && <FormSchoolDetails readOnly={ true } school={ data.data[ 0 ] }/> }
                    </div>
                    <div className='container-for-tabs'>
                        <Tabs defaultActiveKey="teachers" id="teachers-tab" className="mb-3" mountOnEnter={ true }>
                            <Tab eventKey="teachers" title="Teachers">
                                <TeachersContainer provider_id={ encodeURIComponent ( provider_id )} suppressAdd={false}/>
                            </Tab>
                            <Tab eventKey="documents" title="Documents">
                                <DocumentsContainer provider_id={ encodeURIComponent ( provider_id ) }/>
                            </Tab>
                            <Tab eventKey="history" title="History">
                                <HistoryContainer provider_id={ encodeURIComponent ( provider_id ) }/>
                            </Tab>
                            {!isGovernorRole(user_type) && <Tab eventKey="dashboard" title="Dashboard">
                                <TeacherDashboardContainer provider_id={ encodeURIComponent ( provider_id ) }/>
                            </Tab> }
                        </Tabs>
                    </div>
                </div>
            </PageBodyWrapper>
            {renderModal()}
        </Fragment>
    )
}

export default AdminSchoolDetailPageBody;
